import React from "react";
import { MenubarSeparator } from "@/components/ui/menubar";
import JourneyMenuItem from "./JourneyMenuItem";
import { SavedJourney } from "@/utils/storage/types";

interface RootJourneysListProps {
  journeys: SavedJourney[];
  onLoad: (id: string) => void;
  onMove: (journeyId: string, folderId: string | null) => void;
  folders: Array<{ id: string; name: string; }>;
}

const RootJourneysList: React.FC<RootJourneysListProps> = ({
  journeys,
  onLoad,
  onMove,
  folders,
}) => {
  if (journeys.length === 0) return null;
  
  return (
    <>
      <div className="px-2 py-1 text-xs text-muted-foreground">
        Root
      </div>
      {journeys.map((journey) => (
        <JourneyMenuItem 
          key={journey.id}
          journey={journey}
          onLoad={onLoad}
          onMove={onMove}
          folders={folders}
        />
      ))}
      <MenubarSeparator />
    </>
  );
};

export default RootJourneysList;
